<!-- TEMPLATE -->
<template>
  <div :class="deanOverlayTheme"></div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class deanOverlay extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop({ default: false }) light!: boolean;
  @Prop({ default: false }) dark!: boolean;
  @Prop() theme!: object;

  // COMPUTED
  get deanOverlayTheme() {
    let value = 'dean-overlay';
    if (this.dark) value += ` dean-overlay-dark`;
    if (this.light) value += ` dean-overlay-light`;
    else value += ` dean-overlay-light`;
    if (this.theme) {
      value += ` dean-overlay-${this.theme}`;
    }
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-overlay {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 990;
  height: 1000%;
  width: 1000%;
  opacity: 0.8;
}

.dean-overlay-light {
  background-color: white;
}

.dean-overlay-dark {
  background-color: var(--color-dark-shade-2, $color-dark-shade-2);
}
</style>
